/* eslint-disable indent */
import { LikeOutlined, DislikeOutlined } from "@ant-design/icons";
import { Button, Table, Modal } from "antd";
import axios from "axios";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import "katex/dist/katex.min.css";
import Latex from "react-latex-next";

import CreateEditHintModal from "./CreateEditModal";
import { showErrorNotification, showNotification } from "../../../../utils/notification";

const ManageHintsModal = ({
  isModalOpen = false,
  ROOT_URL,
  currentProblemRow = {},
  setProblemsList = () => {},
  setIsModalOpen = () => {}
}) => {
  const { feedback = {}, rating, name, key: problemId } = currentProblemRow;
  const { totalHintsDislikes = 0, totalHintsLikes = 0 } = feedback;

  const [hints, setHints] = useState([]);
  const [isCreateHintModalOpen, setIsCreateHintModalOpen] = useState(false);
  const [initialValues, setInitialValues] = useState({});

  const updateProblemList = (updatedHints) => {
    setProblemsList((prevTasks) => {
      const newTasks = prevTasks.map((problem) => {
        if (problem.key === problemId) {
          return { ...problem, hints: updatedHints };
        }
        return problem;
      });
      return newTasks;
    });
  };

  const handleHintDelete = async (hintId) => {
    try {
      const { data } = await axios.post(`${ROOT_URL}/admin/cp-sheet/problems/hints/delete`, {
        hintId,
        problemId
      });

      const { updatedHints } = data;
      setHints(updatedHints);
      updateProblemList(updatedHints);

      showNotification("Hint deleted Successfully", "Hint deleted Successfully", "success");
    } catch (err) {
      showErrorNotification(err || "Internal Server Error");
    }
  };

  const handleCreateEditHint = async (hintParams) => {
    try {
      const isEdit = !!initialValues?._id;
      const url = isEdit
        ? `${ROOT_URL}/admin/cp-sheet/problems/hints/edit`
        : `${ROOT_URL}/admin/cp-sheet/problems/hints/create`;
      const payload = isEdit
        ? {
            hintParams,
            problemId,
            hintId: initialValues._id
          }
        : {
            hintParams,
            problemId
          };

      const { data } = isEdit ? await axios.put(url, payload) : await axios.post(url, payload);
      const { updatedHints } = data;
      setHints(updatedHints);
      updateProblemList(updatedHints);
      setIsCreateHintModalOpen(false);

      showNotification(
        `Hint ${isEdit ? "edited" : "created"} Successfully`,
        `Hint ${isEdit ? "edited" : "created"} Successfully`,
        "success"
      );
    } catch (err) {
      showErrorNotification(err);
    }
  };

  const columns = [
    {
      title: "Title",
      dataIndex: "title",
      key: "title"
    },
    {
      title: "Content",
      dataIndex: "content",
      key: "content",
      render: (row) => (
        <div>
          <Latex>{row}</Latex>
        </div>
      )
    },
    {
      title: "Updated At",
      dataIndex: "updatedAt",
      key: "updatedAt",
      render: (updatedAt) => (updatedAt ? dayjs(updatedAt).format("DD MMM YYYY | HH:mm") : "--")
    },
    {
      title: "Unlock Time (seconds)",
      dataIndex: "unlockAtSeconds",
      key: "unlockAtSeconds",
      render: (seconds) => seconds || 0
    },
    {
      title: "Actions",
      key: "action",
      render: (row) => (
        <div
          id="section_hints_actions"
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-around"
          }}
        >
          <Button
            type="primary"
            onClick={() => {
              setInitialValues(row);
              setIsCreateHintModalOpen(true);
            }}
          >
            Edit
          </Button>
          <Button
            type="primary"
            danger
            onClick={() => {
              handleHintDelete(row._id);
            }}
          >
            Delete
          </Button>
        </div>
      )
    }
  ];

  useEffect(() => {
    setHints(currentProblemRow.hints || []);
  }, [currentProblemRow.hints]);

  return (
    <Modal
      title={`${rating} | ${name}`}
      centered
      open={isModalOpen}
      footer={[]}
      onOk={() => {
        setIsModalOpen(false);
      }}
      style={{ minWidth: "50vw" }}
      width={"auto"}
      onCancel={() => setIsModalOpen(false)}
      destroyOnClose
    >
      <div
        style={{
          marginBottom: "16px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center"
        }}
      >
        <Button
          type="primary"
          onClick={() => {
            setInitialValues({});
            setIsCreateHintModalOpen(true);
          }}
        >
          {" "}
          Create New Hint
        </Button>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "16px",
            fontSize: "14px"
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
            <LikeOutlined style={{ color: "#52c41a" }} />
            <span>{totalHintsLikes}</span>
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
            <DislikeOutlined style={{ color: "#ff4d4f" }} />
            <span>{totalHintsDislikes}</span>
          </div>
        </div>
      </div>
      <div>
        <b>User Hint feedback is considered if it was marked after the hint was last updated.</b>
      </div>
      <Table
        columns={columns}
        bordered
        pagination={false}
        dataSource={hints}
        scroll={{ x: "max-content" }}
      />
      {isCreateHintModalOpen === true && (
        <CreateEditHintModal
          isModalOpen={isCreateHintModalOpen}
          setIsModalOpen={setIsCreateHintModalOpen}
          initialValues={initialValues}
          isEdit={initialValues?._id !== undefined}
          handleCreateEdit={handleCreateEditHint}
        />
      )}
    </Modal>
  );
};

export default ManageHintsModal;
